import {
  type SeverityLevel,
  captureException,
  captureMessage,
} from '@sentry/react';

type ExceptionContext = Parameters<typeof captureException>['1'];

type MessageContext = Exclude<
  Parameters<typeof captureMessage>['1'],
  SeverityLevel
>;

export const monitoringMessageHelper = (
  message: string,
  context?: MessageContext
) => {
  captureMessage(message, {
    level: 'warning',
    ...context,
  });
};

export const monitoringExceptionHelper = (
  error: any,
  context?: ExceptionContext
) => {
  captureException(error, context);
};
